export const iconFontAwesomeHumanitarianWalkieTalkie = (
	<i className="fa-solid fa-walkie-talkie"></i>
);
